import * as querystring from 'query-string'
import * as redux from 'redux'
import { ThunkAction } from 'redux-thunk'

import axiosVerbose from '../../utils/axios/axiosVerbose'
import { logError } from '../../utils/errors'

import { ILoadDataOptions } from '../../../typings/loadDataOptions'
import { ISearchResults } from '../../../typings/searchResults'
import { ISeoMetadata } from '../../../typings/seoMetadata'
import { IRootState } from '../../reducers'

export enum TypeKeys {
  GET_NEWEST_ITEMS_BY_CATEGORY_PENDING = 'GET_NEWEST_ITEMS_BY_CATEGORY_PENDING',
  GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS = 'GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS',
  GET_NEWEST_ITEMS_BY_CATEGORY_FAIL = 'GET_NEWEST_ITEMS_BY_CATEGORY_FAIL'
}

interface IPendingPayload {
  readonly category: string
}

interface ISuccessPayload {
  readonly category: string
  readonly searchResults: Readonly<ISearchResults>
}

export interface IGetNewestItemsByCategoryPendingAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
  readonly payload: IPendingPayload
}

export interface IGetNewestItemsByCategorySuccessAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
  readonly payload: ISuccessPayload
}

export interface IGetNewestItemsByCategoryFailAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
}

export type ActionTypes =
  | IGetNewestItemsByCategoryPendingAction
  | IGetNewestItemsByCategorySuccessAction
  | IGetNewestItemsByCategoryFailAction

export const fetchNewestItemsByCategory = (
  category: string
): ThunkAction<
  Promise<
    IGetNewestItemsByCategorySuccessAction | IGetNewestItemsByCategoryFailAction
  >,
  IRootState,
  any
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common
    let query
    if (category === 'all') {
      query = { site: `${currentSite}.net`, page_size: 40, sort_by: 'date' }
    } else {
      query = {
        category,
        page_size: 40,
        site: `${currentSite}.net`,
        sort_by: 'date'
      }
    }
    dispatch({
      payload: { category },
      type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
    })
    return axiosVerbose
      .get(`/shopfront_api/search?${querystring.stringify(query)}`)
      .then(response => {
        const successAction: IGetNewestItemsByCategorySuccessAction = {
          payload: { searchResults: response.data, category },
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
        }
        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const failAction: IGetNewestItemsByCategoryFailAction = {
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
        }
        return dispatch(failAction)
      })
  }
}



// WEBPACK FOOTER //
// ./common/actions/home/fetchNewestItemsByCategory.ts